// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Basic-module--wrapper--67vSn"};